import BlockPoint from './block-point';
import { computed } from '@ember/object';
import { and, not } from '@ember/object/computed';
import { equalToProperty } from '@intercom/pulse/lib/computed-properties';
import Em from 'ember';
export default Em.Object.extend({
  startPoint: null,
  endPoint: null,
  shiftRightBy(delta) {
    this.incrementProperty('startPoint.positionIndex', delta);
    this.incrementProperty('endPoint.positionIndex', delta);
  },
  shiftLeftBy(delta) {
    this.decrementProperty('startPoint.positionIndex', delta);
    this.decrementProperty('endPoint.positionIndex', delta);
  },
  expandLeftBy(delta) {
    this.decrementProperty('startPoint.positionIndex', delta);
  },
  setup: Em.on('init', function () {
    this.setProperties({
      startPoint: BlockPoint.create(),
      endPoint: BlockPoint.create()
    });
  }),
  bothPointsAreAtFirstItem: and('startPoint.isFirstItem', 'endPoint.isFirstItem'),
  length: Em.computed('startPoint.{positionIndex,isFirstItem}', 'endPoint.{positionIndex,isFirstItem}', function () {
    if (this.get('bothPointsAreAtFirstItem')) {
      return this.get('endPoint.positionIndex') - this.get('startPoint.positionIndex');
    } else {
      throw new Error('BlockRange length is invalid as both point itemIndexes are not 0');
    }
  }),
  isAtStart: and('startPoint.isAtStart', 'endPoint.isAtStart'),
  hasNoLength: equalToProperty('startPoint.info', 'endPoint.info'),
  hasLength: not('hasNoLength'),
  info: computed('startPoint.info', 'endPoint.info', function () {
    return `${this.startPoint.info} -> ${this.endPoint.info}`;
  }),
  collapse() {
    //TODO: GJ: tests
    this.set('endPoint.itemIndex', this.get('startPoint.itemIndex'));
    this.set('endPoint.positionIndex', this.get('startPoint.positionIndex'));
  }
}).reopenClass({
  atPositionIndex(startPositionIndex, endPositionIndex) {
    endPositionIndex = endPositionIndex || startPositionIndex;
    let range = this.create();
    range.set('startPoint.positionIndex', startPositionIndex);
    range.set('endPoint.positionIndex', endPositionIndex);
    return range;
  },
  atItemAndPositionIndex(startItemIndex, startPositionIndex, endItemIndex, endPositionIndex) {
    endItemIndex = endItemIndex || startItemIndex;
    endPositionIndex = endPositionIndex || startPositionIndex;
    let range = this.create();
    range.set('startPoint.positionIndex', startPositionIndex);
    range.set('startPoint.itemIndex', startItemIndex);
    range.set('endPoint.positionIndex', endPositionIndex);
    range.set('endPoint.itemIndex', endItemIndex);
    return range;
  }
});